module.exports = __webpack_public_path__ + "img/img-dices.424dfa1a.png";